<template>
	<div class="event-statistic__graph">
		<form class="event-statistic__range" @submit.prevent="search">
			<DateBox v-if="timeCount" v-model="timeDate" type="date" />
			<DateRange v-else v-model="dateRange" type="date" />
			<div class="event-statistic__button">
				<button
					type="submit"
					class="btn-main blue"
					v-text="'검색하기'"
				/>
				<button
					type="button"
					class="btn-main blue bordered"
					@click="init"
				>
					초기화
				</button>
			</div>
		</form>
		<Chart :options="chartOptions" ref="chart" />
	</div>
</template>
<script>
	import { Chart } from 'highcharts-vue';
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import DateBox from '@/components/DateBox';
	import DateRange from '@/components/DateRange';
	import moment from 'moment';

	export default {
		name: 'EventApplication',
		components: {
			ManagingSection,
			ManagingBox,
			DateBox,
			DateRange,
			Chart,
		},
		props: {
			title: {
				type: String,
				required: true,
			},
			action: {
				type: String,
				default: '',
			},
			timeCount: {
				type: Boolean,
				default: false,
			},
			dailyCount: {
				type: Boolean,
				default: false,
			},
			yAxisTitle: {
				type: String,
				default: '응모수',
			},
		},
		watch: {
			action() {
				this.getList();
			},
			dateRange() {
				this.setFromDate =
					this.dateRange.from ||
					moment().subtract(7, 'd').format('YYYY-MM-DD');
				this.setToDate =
					this.dateRange.to ||
					moment().subtract(1, 'd').format('YYYY-MM-DD');
			},
			timeDate() {
				this.setCurrentDate =
					this.timeDate || moment().format('YYYY-MM-DD');
			},
		},
		mounted() {
			this.getList();
		},
		data() {
			return {
				xAxisCategory: [],
				series: [],
				setFromDate: moment().subtract(7, 'd').format('YYYY-MM-DD'),
				setToDate: moment().subtract(0, 'd').format('YYYY-MM-DD'),
				setCurrentDate: moment().format('YYYY-MM-DD'),
				timeDate: '',
				dateRange: {
					from: '',
					to: '',
				},
				handleAction: {
					gender: this.matchGenderData,
					age: this.matchAgeData,
					skinType: this.matchSkinData,
					totalCount: this.matchTotalData,
					timeCount: this.matchTimeData,
					daliyReview: this.matchDailyReview,
					periodReview: this.matchPeriodReview,
				},
				chartOptions: {
					chart: {
						type:
							this.action === 'daliyReview' ? 'spline' : 'column',
					},
					title: {
						text: this.title,
					},
					xAxis: {
						categories: [],
						crosshair: true,
					},
					yAxis: {
						min: 0,
						title: {
							text: this.yAxisTitle,
						},
					},
					plotOptions: {
						column: {
							pointPadding: 0.1,
							borderWidth: 0,
						},
					},
					series: [
						{
							name: '',
							data: [],
						},
					],
				},
			};
		},
		methods: {
			search() {
				if (!this.timeCount) {
					if (!this.validation()) return false;
				}
				this.getList();
			},
			init() {
				this.dateRange = {
					from: '',
					to: '',
				};
				this.timeDate = '';
				this.setCurrentDate = moment().format('YYYY-MM-DD');
				this.setFromDate = moment()
					.subtract(7, 'd')
					.format('YYYY-MM-DD');
				this.setToDate = moment().subtract(1, 'd').format('YYYY-MM-DD');
				this.getList();
			},
			validation() {
				if (!this.dateRange.to || !this.dateRange.from) {
					alert('날짜를 입력해 주세요');
					return false;
				}
				if (
					moment(this.dateRange.from).valueOf() >
					moment(this.dateRange.to).valueOf()
				) {
					alert('종료일시는 시작일시보다 빠를 수 없습니다.');
					return false;
				}
				if (!!this.dateRange.to && !!this.dateRange.from) {
					const startDate = moment(this.dateRange.from);
					const endDate = moment(this.dateRange.to);
					const dateDifference = moment
						.duration(endDate.diff(startDate))
						.asDays();
					if (dateDifference > 30) {
						alert('날짜범위는 최대 31일을 넘어갈수 없습니다.');
						return false;
					}
					return true;
				}
			},
			getList() {
				try {
					this.$store.commit('toggleSpinner', true);
					switch (true) {
						case this.timeCount:
							this.getTimeData();
							break;
						case this.dailyCount:
							this.getReviewData();
							break;
						default:
							this.getDailyData();
							break;
					}
				} catch (err) {
					console.err(err);
					this.$store.commit('toggleSpinner', false);
					alert(
						'리스트 불러오는것을 실패하였습니다. 개발팀에 문의하세요.'
					);
				}
			},
			getDailyData() {
				const setEndDate = new Date(this.setToDate);
				setEndDate.setDate(setEndDate.getDate() + 1);
				const setEndAt = setEndDate.toISOString().slice(0, 10);
				const params = {
					startAt: this.setFromDate,
					endAt: setEndAt,
					action: this.action,
				};
				const endPoint = '/api/aggregate/event/daily';
				const actionHandler = this.handleAction[this.action];
				this.getData(endPoint, params, actionHandler);
			},
			getTimeData() {
				const action = 'all';
				const params = {
					date: this.setCurrentDate,
					action,
				};
				const endPoint = '/api/aggregate/event/hourly';
				const actionHandelr = this.handleAction.timeCount;
				this.getData(endPoint, params, actionHandelr);
			},

			getReviewData() {
				const setEndDate = new Date(this.setToDate);
				setEndDate.setDate(setEndDate.getDate() + 1);
				const setEndAt = setEndDate.toISOString().slice(0, 10);
				const params = {
					startAt: this.setFromDate,
					endAt: setEndAt,
				};
				const endPoint = '/api/aggregate/review/daily';
				const actionHandelr = this.handleAction[this.action];
				this.getData(endPoint, params, actionHandelr);
			},

			async getData(endPoint, params, actionHandler) {
				const { data } = await this.$axiosAdmin2.get(endPoint, {
					params,
				});
				if (actionHandler !== this.handleAction.timeCount) {
					data?.pop();
				}
				const setData = data.map(item => item.key);
				this.xAxisCategory = setData;
				if (actionHandler) {
					actionHandler.call(this, data);
				}
				this.updateDateChart();
			},

			matchGenderData(data) {
				const genderTypeList = ['남성', '여성', '기타응모자'];
				const dataTypeList = ['maleCount', 'femaleCount', 'etcCount'];
				this.matchData(data, genderTypeList, dataTypeList);
			},
			matchAgeData(data) {
				const ageTypeList = [
					'10대',
					'20대',
					'30대',
					'40대',
					'기타응모자',
				];
				const dataTypeList = [
					'teensCount',
					'twentiesCount',
					'thirtiesCount',
					'fortiesCount',
					'etcCount',
				];
				this.matchData(data, ageTypeList, dataTypeList);
			},
			matchSkinData(data) {
				const skinTypeList = [
					'건성',
					'지성',
					'중성',
					'복합성',
					'민감성',
					'기타응모자',
				];
				const dataTypeList = [
					'dryCount',
					'oilyCount',
					'neutralCount',
					'combinationCount',
					'sensitiveCount',
					'etcCount',
				];
				this.matchData(data, skinTypeList, dataTypeList);
			},

			matchTotalData(data) {
				const totalCountList = ['이벤트 응모 수'];
				const dataTypeList = ['totalCount'];
				this.matchData(data, totalCountList, dataTypeList);
			},

			matchTimeData(data) {
				const tiemCountList = ['시간별 응모 수'];
				const dataTypeList = ['totalCount'];
				this.matchData(data, tiemCountList, dataTypeList);
			},

			matchDailyReview(data) {
				const dailyReviewList = [
					'전체 리뷰수',
					'1점대 리뷰수',
					'2점대 리뷰수',
					'3점대 리뷰수',
					'4점대 리뷰수',
					'5점대 리뷰수',
				];
				const dataTypeList = [
					'totalCount',
					'rating1Count',
					'rating2Count',
					'rating3Count',
					'rating4Count',
					'rating5Count',
				];
				this.matchData(data, dailyReviewList, dataTypeList);
			},

			matchPeriodReview(data) {
				const dailyReviewList = ['리뷰수'];
				const dataTypeList = ['totalCount'];
				this.matchData(data, dailyReviewList, dataTypeList);
			},

			matchData(data, typeList, dataTypeList) {
				const result = typeList.map(list => ({ name: list, data: [] }));
				data.forEach((item, idx) => {
					const dataType =
						this.action === 'daliyReview' ||
						this.action === 'periodReview'
							? item.reviewAggregate
							: item.eventCandidateAggregateGroup?.[this.action];
					if (!dataType) {
						result.forEach(type => (type.data[idx] = 0));
					} else {
						result.forEach((type, index) => {
							type.data[idx] =
								this.action === 'totalCount'
									? dataType
									: dataType[dataTypeList[index]];
						});
					}
				});
				this.series = result;
			},

			updateDateChart() {
				this.chartOptions = {
					...this.chartOptions,
					title: {
						text: this.title,
					},
					subtitle: {
						text: `${this.timeCount ? this.setCurrentDate : ''}`,
					},
					xAxis: {
						categories: this.xAxisCategory,
					},
					series: this.series,
				};
			},
		},
	};
</script>
<style lang="scss" scoped>
	.event-statistic {
		&__graph {
			margin-top: 50px;
			position: relative;
		}

		&__range {
			display: flex;
			margin-bottom: 60px;
			padding-left: 26px;
		}

		&__button {
			display: flex;
			align-items: center;
			margin-left: 20px;
			button {
				border-radius: 4px !important;
				margin: 0;
				height: 35px;
				line-height: 35px;
				& + button {
					margin-left: 10px;
				}
			}
		}
	}
</style>
